import { logWrapper } from '../utils';

function ngModalSizeDirectiveFactory(runtimeConstant, $timeout) {
  function fitModalBody(element) {
    const header = element.find('.modal-header');
    const body = element.find('.modal-body');
    const form = element.find('form');
    const formHeader = element.find('.tab-nav');
    const list = element.find('.listview .lv-body');
    const listHeader = element.find('.listview .lv-header');
    const listSelectAll = element.find('.listview .lv-item.select-all');
    const footer = element.find('.modal-footer');
    const modalContainer = element.parent().parent().parent();
    const modalDialog = element.parent().parent();

    const dialogHeight =
      parseInt(modalContainer.css('height')) -
      parseInt(modalDialog.css('margin-top')) -
      parseInt(modalDialog.css('margin-bottom'));

    modalDialog.css('height', `${dialogHeight}px`);

    const modalHeight = parseInt(modalDialog.css('height'));
    const headerHeight = parseInt(header.css('height'));
    const footerHeight = parseInt(footer.css('height')) || 0;
    const formHeaderHeight = parseInt(formHeader.css('height'));
    const height = modalHeight - 5;

    const bodyMaxHeight = height - headerHeight - footerHeight;
    body.css('max-height', `${bodyMaxHeight}px`);
    body.css('overflow', form.length > 0 ? 'hidden' : 'auto');
    body.css('-ms-overflow-style', form.length > 0 ? '-ms-autohiding-scrollbar' : 'auto');

    let style = body.attr('style');
    style = style.replace(
      `max-height: ${bodyMaxHeight}px`,
      `max-height: ${bodyMaxHeight}px !important`
    );
    body.attr('style', style);

    if (form.length > 0) {
      const listHeaderHeight =
        parseInt(listHeader.css('height')) +
        parseInt(listHeader.css('padding-top')) +
        parseInt(listHeader.css('padding-bottom'));
      const listSelectAllHeight =
        parseInt(listSelectAll.css('height')) +
        parseInt(listSelectAll.css('padding-top')) +
        parseInt(listSelectAll.css('padding-bottom'));

      const listHeight =
        height - footerHeight - listHeaderHeight - listSelectAllHeight - 5;
      const formHeight = height - footerHeight - formHeaderHeight - 40;

      list.css('max-height', `${listHeight}px`);
      list.css('overflow-y', 'auto');
      list.css('-ms-overflow-style', 'auto');
      form.css('max-height', `${formHeight}px`);
      form.css('overflow-y', 'auto');
      form.css('-ms-overflow-style', 'auto');
    }
  }

  function run() {
    return {
      scope: {
        trigger: '=?ngModalSize',
      },
      link: function (scope, element) {
        $timeout(() => fitModalBody(element));

        if (scope.trigger !== undefined) {
          scope.$watch('trigger', function () {
            $timeout(() => fitModalBody(element));
          });
        }
      },
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const ngModalSizeDirective = ['runtimeConstant', '$timeout', ngModalSizeDirectiveFactory];
